import { createSlice } from "@reduxjs/toolkit";
import {
    loginUser,
    registerUser,
    requestPasswordReset,
    resetPassword,
} from "./authThunks";

const initialState = {
    user: null,
    isAuthenticated: false,
    loading: false,
    error: null,
    registrationSuccess: false,
    // Forgot / Reset password
    passwordResetRequested: false,  // OTP sent successfully
    passwordResetSuccess: false,    // Password changed successfully
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        logout: (state) => {
            state.user = null;
            state.isAuthenticated = false;
            state.error = null;
            state.registrationSuccess = false;
            state.passwordResetRequested = false;
            state.passwordResetSuccess = false;
        },
        clearError: (state) => {
            state.error = null;
            state.loading = false;
            state.registrationSuccess = false;
            state.passwordResetRequested = false;
            state.passwordResetSuccess = false;
        },
        setUser: (state, action) => {
            state.user = action.payload;
            state.isAuthenticated = !!action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            // ── Login ──────────────────────────────────────────────────────
            .addCase(loginUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(loginUser.fulfilled, (state, action) => {
                state.loading = false;
                state.isAuthenticated = true;
                state.user = action.payload;
            })
            .addCase(loginUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Login failed";
            })

            // ── Register ───────────────────────────────────────────────────
            .addCase(registerUser.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.registrationSuccess = false;
            })
            .addCase(registerUser.fulfilled, (state) => {
                state.loading = false;
                state.registrationSuccess = true;
                state.error = null;
            })
            .addCase(registerUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Registration failed";
                state.registrationSuccess = false;
            })

            // ── Forgot Password ────────────────────────────────────────────
            .addCase(requestPasswordReset.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.passwordResetRequested = false;
            })
            .addCase(requestPasswordReset.fulfilled, (state) => {
                state.loading = false;
                state.passwordResetRequested = true;
                state.error = null;
            })
            .addCase(requestPasswordReset.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to send OTP";
                state.passwordResetRequested = false;
            })

            // ── Reset Password ─────────────────────────────────────────────
            .addCase(resetPassword.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.passwordResetSuccess = false;
            })
            .addCase(resetPassword.fulfilled, (state) => {
                state.loading = false;
                state.passwordResetSuccess = true;
                state.error = null;
            })
            .addCase(resetPassword.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to reset password";
                state.passwordResetSuccess = false;
            });
    },
});

export const { logout, clearError, setUser } = authSlice.actions;
export default authSlice.reducer;
